<template>
  <div id="app_signup">
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <ServerError v-if="ServerError" />

    <v-snackbar v-model="showsnackbar" color="#00a972" right :timeout="timeout">
      {{msg}}
      <v-btn text @click="showsnackbar = false">
        <v-icon style="color:white;">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-layout wrap justify-space-around>
      <v-flex xs12 md12 pa-8>
        <v-card outlined tile style="min-height:90vh">
          <v-layout wrap pt-10 justify-center>
            <v-flex xs12 md12 text-center>
              <span style="font-size:20px;font-weight:500;">Investment Declarations</span>
            </v-flex>
            <v-flex xs12 md3 text-center px-4>
              <span v-if="userType == 'Individual'">Individual Investor</span>
              <span v-if="userType=='Company'">Company Account</span>
              <v-progress-linear :value="100" color="#fb6b0b" height="2"></v-progress-linear>
            </v-flex>
            <v-flex xs12 md12 pt-2 text-center>
              <span style="font-sizer:14px;font-weight:400;color:#a9a9a9">{{userEmail}}</span>
            </v-flex>
          </v-layout>
          <v-layout wrap justify-center>
            <v-flex xs12 sm12 md8 text-center>
              <div v-for="(item,i) in disclosure" :key="i">
                <v-layout py-2 px-4 wrap align-center justify-end>
                  <v-flex xs12 sm10 md10 text-left>
                    <span style="font-size:16px;font-weight:500;">{{item.name}}</span>
                  </v-flex>
                  <v-flex xs3 sm2 md2 text-right>
                    <v-switch
                      v-model="item.value"
                      :disabled="item.value"
                      :ripple="false"
                      color="#00a972"
                    >
                      <template slot="label">
                        <span
                          v-if="item.value"
                          style="font-size:16px;font-weight:500;color:#00a972"
                        >Yes</span>
                        <span v-else style="font-size:16px;font-weight:400;color:red">No</span>
                      </template>
                    </v-switch>
                  </v-flex>
                </v-layout>
                <!-- <v-divider></v-divider> -->
              </div>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs12 md12 pa-10 text-center>
              <br />
              <v-btn
                width="220"
                class="text-capitalize"
                :ripple="false"
                color="#26af82"
                dark
                small
                @click="submit"
              >Submit</v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      disclosure: [
        {
          name:
            "I have read and understood the disclosures and am interested in the offer of securities",
          value: false
        },
        {
          name:
            "I have read and understood the risks associated with these investments",
          value: false
        },
        { name: "I am able to lose all my capital", value: false },
        {
          name:
            "I am able to hold my investment for multiple years (at least 5)",
          value: false
        },
        {
          name: "I can accept and tolerate variability in returns",
          value: false
        },
        {
          name: "What matters more is that the agreed impact is delivered",
          value: false
        },
        {
          name:
            "I understand there is a cooling-off period of 2 weeks during which I can reconsider my investment choice",
          value: false
        },
        {
          name:
            "I understand the nature of equity and debt investments and their risks ",
          value: false
        }
      ],
      msg: null,
      appLoading: false,
      userEmail: localStorage.getItem("email"),
      userType: localStorage.getItem("userType"),
      formHasError: false,
      showsnackbar: false,
      timeout: 5000,
      ServerError: false
    };
  },
  beforeMount() {},
  methods: {
    submit() {
      this.formHasError = false;
      for (var i = 0; i < this.disclosure.length; i++) {
        if (!this.disclosure[i].value) {
          this.formHasError = true;
          this.msg = "Please accept all disclosure";
          this.showsnackbar = true;
          return;
        }
      }
      if (!this.formHasError) {
        var data = {};
        data["disclosure"] = this.disclosure;
        data["id"] = localStorage.getItem("userId");
        axios({
          method: "POST",
          url: "/user/edit",
          headers: {
            "x-auth-token": localStorage.getItem("token")
          },
          data: data
        })
          .then(response => {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showsnackbar = true;
            if (response.data.status) {
              this.$router.push("/BankDetails");
            }
          })
          .catch(err => {
            this.msg = err;
            this.ServerError = true;
          });
      }
    }
  }
};
</script>
<style scoped>
#app_signup {
  background-image: url("../../assets/home_header.png");
  background-repeat: no-repeat;
  background-size: cover;
  color: white;
}
.confbox >>> label {
  color: black !important;
  font-size: 11px !important;
  line-height: 12px !important;
}
.upload-btn-wrapper {
  position: relative;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
</style>